
export const ErrorComp = () => {
    return (
        <div className="error">
            <div>Server Error</div>
        </div>
    );
};
